
import {FC, useMemo} from "react";
import {Script} from "@common-core/react-composable/script-injector";
import {WhenDefined} from "@common-core/react-composable/custom-elements";
import {useEnvironment} from "@common-core/react-runtime/context";
import {Environment} from "../runtime";
import {useItemIsVisible} from "../visibility";
import {useSearchParams} from "../hooks";
import {EmbeddedComponent} from "./EmbeddedComponent";
import {buildEmbeddedComponentOverride} from "./buildEmbeddedComponentOverride";

export const EmbeddedComponentPreLoader: FC = () => {
  const params = useSearchParams();
  const {sidebarComponents, tabComponents, historyComponent} =
    useEnvironment<Environment>();
  const isVisible = useItemIsVisible<EmbeddedComponent>();
  const components = useMemo<EmbeddedComponent[]>(() => {
    return [...sidebarComponents, ...tabComponents, historyComponent]
      .filter(component => component?.preload)
      .filter(isVisible);
  }, [sidebarComponents, tabComponents, historyComponent, isVisible]);

  return components
    .map(component => buildEmbeddedComponentOverride(params, component))
    .map(override => {
      console.info(
        `Preloading web component module ${override.script.id}, waiting for IDS web components...`
      );
      return (
        // Wait until the last IDS web component is defined in the registry before injecting the embedded component script
        <WhenDefined
          key={override.script.id}
          element={"ids-vin-input"}
          placeholder={() => null}>
          <Script {...override.script} />
        </WhenDefined>
      );
    });
};
